'use client';

import { useInject } from '@actr/di';
import { baseLog } from '@actr/logger';
import { MindboxUtils } from '@actr/logger/src/utils/mindbox';
import { AppStore } from '@actr/stores/src/stores/stores/common/app';
import { canUseDom } from '@actr/utilities/src/dom';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { YMInitializer } from 'react-yandex-metrika';

import config from '@/configs';

import YandexMetrika from './yandex';

const OptionalMetricsConnection = () => {
  const app = useInject(AppStore);
  const { isCookieAccepted } = app;

  // eslint-disable-next-line consistent-return
  function connectYM() {
    const isMetricEnabled = !!config.YM_TrackingID && config.metricsTracking.yandexMetrics && config.app.trackingEnable;
    if (isMetricEnabled) {
      if (canUseDom) {
        baseLog.send('ym_connected', undefined, { once: true });
      }
      return (
        <>
          <YMInitializer
            accounts={[parseInt(config.YM_TrackingID, 10)]}
            version="2"
            options={config.yandexMetricsOptions}
          />
          <YandexMetrika />
        </>
      );
    }
    return null;
  }

  useEffect(() => {
    const { isMetricEnabled } = MindboxUtils;

    if (isCookieAccepted && isMetricEnabled) {
      MindboxUtils.createScript();
    }
  }, [isCookieAccepted]);

  return isCookieAccepted ? connectYM() : null;
};

export default observer(OptionalMetricsConnection);
